import React, { useCallback } from 'react';
import css from './YearBlock.module.scss';
import classnames from 'classnames';

const YearBlock = ({ activeYear, yearSetter, setOpenYear, years }) => {
    const selectYear = useCallback(
        (year) => {
            yearSetter(year);
            setOpenYear((pre) => !pre);
        },
        [setOpenYear, yearSetter]
    );
    return (
        <div className='dpHeader__yearData custom-scroll'>
            {years.map((year) => (
                <button
                    key={`datepicker${year}${Date.now()}`}
                    type='button'
                    onClick={() => selectYear(year)}
                    className={classnames(
                        css.dpHeader__yearData__item,
                        activeYear === year && css.dpHeader__yearData__item_seleted
                    )}
                >
                    {year}
                </button>
            ))}
        </div>
    );
};
export default YearBlock;
